import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "context/LanguageContext";
import {
  NotificationProvider,
  useNotification
} from "context/NotificationContext"; // Importa o Provider e o hook
import { jwtDecode } from "jwt-decode";

const EntraForm = () => {
  const navigate = useNavigate();
  const { GetTranslation } = useLanguage();
  const showNotification = useNotification(); // Hook para exibir notificação

  const [Erro, setErro] = useState(false);

  const SeLogar = async (event) => {
    event.preventDefault();
    setErro(false);
    const formData = new FormData(event.target);

    const data = {
      usuario: formData.get("usuario"),
      senha: formData.get("senha")
    };

    try {
      // Enviar os dados de login para o back-end usando fetch
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();

      if (result.success) {
        // Armazenar o token no localStorage
        localStorage.setItem("token", result.token);

        // Se o login for bem-sucedido, redirecionar o usuário
        showNotification({
          type: "success",
          message: GetTranslation("login_success")
        });
        navigate("/app");
      } else {
        setErro(true);
        showNotification({
          type: "error",
          message: GetTranslation("invalid_data")
        });
      }
    } catch (error) {
      setErro(true);
      showNotification({
        type: "error",
        message: GetTranslation("invalid_data")
      });
    }
  };

  return (
    <form className="form-login" onSubmit={SeLogar}>
      <div className="mb-3">
        <label htmlFor="usuario" className="form-label">
          {GetTranslation("user")}
        </label>
        <input
          type="text"
          name="usuario"
          className="form-control"
          id="usuario"
        />
      </div>
      <div className="mb-3">
        <label htmlFor="senha" className="form-label">
          {GetTranslation("password")}
        </label>
        <input
          type="password"
          name="senha"
          className="form-control"
          id="senha"
        />
      </div>
      <div className="d-flex justify-content-center">
        <button type="submit" className="btn btn-primary">
          {GetTranslation("login")}
        </button>
      </div>
    </form>
  );
};

// Envolvendo com NotificationProvider
const Entra = () => (
  <EntraForm />
);

export default Entra;
